import { jsx as i } from "react/jsx-runtime";
import { useTranslation as l } from "react-i18next";
import { RadioButtonGroup as L } from "../../../../../components/form-elements/radio-button-group/radio-button-group.js";
import { trailerTypeConfig as E, TrailerType as a } from "../../../helpers/trailer-filter-helper.js";
import u from "./trailer-type-filter-radio-buttons.module.less.js";
const p = (R, n, o) => {
  switch (R) {
    case "TRAILER":
      return o("TRAILER_RENTAL_FILTER_TRAILER_LABEL", { numberOfTrailers: n });
    case "BOAT_TRAILER":
      return o("TRAILER_RENTAL_FILTER_BOAT_TRAILER_LABEL", { numberOfTrailers: n });
    case "CAR_TRAILER":
      return o("TRAILER_RENTAL_FILTER_CAR_TRAILER_LABEL", { numberOfTrailers: n });
    default:
      return null;
  }
}, A = (R, n) => {
  if (!R)
    return null;
  const o = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  for (const [r, e] of Object.entries(E))
    if (t.set(r, 0), e)
      for (const T of e)
        o.set(T, r);
  for (const r of R) {
    const e = o.get(r.trailerTypeId);
    e ? t.set(e, t.get(e) + 1) : t.set(a.TRAILER, t.get(a.TRAILER) + 1);
  }
  const s = [];
  for (const [r, e] of t.entries()) {
    const T = p(r, e, n);
    s.push({ label: T, value: r, id: r });
  }
  return s;
}, m = ({
  dispatch: R,
  availableTrailers: n,
  trailerTypeFilter: o
}) => {
  const { t } = l(), s = A(n, t);
  return s ? /* @__PURE__ */ i("div", { className: u.wrapper, children: /* @__PURE__ */ i(
    L,
    {
      name: "trailerTypeFilter",
      onChange: (r, e) => {
        R({ type: "SELECT_TRAILER_TYPE_FILTER", payload: { trailerType: e } });
      },
      value: o,
      label: t("TRAILER_RENTAL_TRAILER_TYPE_FILTER_LABEL"),
      radioButtons: s ?? []
    }
  ) }) : null;
};
export {
  m as TrailerTypeFilterRadioButtons,
  m as default
};
